module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading || _vm.loadingForProducts
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('header', {
    staticClass: "c-toolbar"
  }, [_c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.fromModuleDefinition.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i-arrow icon-arrow-right"
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.toModuleDefinition.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "c-toolbar__title title"
  }, [_vm._v("Disponibilizar produtos")])])])]) : _vm._e(), _vm._v(" "), (_vm.toModule && _vm.toModule.identifier === 'shopee') ? _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('shopee.account.label'),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAccount),
      expression: "selectedAccount"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shopeeAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account
      }
    }, [_vm._v(_vm._s(((account.shopName) + " (" + (account.shopId) + ")")) + "\n          ")])
  }), 0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.toModule && _vm.toModule.identifier === 'tikTokShop') ? _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('tikTokShop.account.label'),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAccount),
      expression: "selectedAccount"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Selecione uma conta")]), _vm._v(" "), _vm._l((_vm.tikTokShopAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account
      }
    }, [_vm._v(_vm._s(("" + (account.nickname))) + "\n          ")])
  })], 2)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.toModule && _vm.toModule.identifier === 'shein') ? _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('shein.account.label'),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAccount),
      expression: "selectedAccount"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Selecione uma conta")]), _vm._v(" "), _vm._l((_vm.sheinAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account
      }
    }, [_vm._v(_vm._s(("" + (account.nickname))) + "\n          ")])
  })], 2)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.toModule && _vm.toModule.identifier === 'magalu') ? _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('magalu.account.label'),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAccount),
      expression: "selectedAccount"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Selecione uma conta")]), _vm._v(" "), _vm._l((_vm.magaluAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account
      }
    }, [_vm._v(_vm._s(("" + (account.identifier))) + "\n          ")])
  })], 2)])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c(_vm.marketplaceProvideProduct, {
      key: product,
      ref: "marketplaceProvideProduct",
      refInFor: true,
      tag: "component",
      attrs: {
        "product": product,
        "toModule": _vm.toModule,
        "fromModule": _vm.fromModule,
        "account": _vm.selectedAccount
      }
    })
  }), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('provide.label')))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bad0d0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductProvide/Provide.vue
// module id = 3197
// module chunks = 0